import styled from "styled-components";

export const LoadingContainer = styled.div`
`;

export const FakeTableRow = styled.div`
  padding: var(--space-s) var(--space-base);
  margin-bottom: 0;
`;
